<div style="min-width: 100%; height: 100%;" #healthDiv>
    <div class="alignRow">
        <span style="font-size: large; font-weight: bolder;">System Health</span>
        <span *ngIf="Datapoints.length > 0" class="app-icon app-icon--sensorOffline" style="margin-left: 1em;"
            matTooltip="One or More DataPoints Offline"><mat-icon /></span>
        <span *ngIf="Datapoints.length == 0" class="app-icon app-icon--sensors" style="margin-left: 1em; color: rgb(0, 204, 0);"
            matTooltip="No Sensors Offline"><mat-icon /></span>

        <span *ngIf="Rules.length > 0" class="app-icon app-icon--notifications-active" style="margin-left: 1em;"
            matTooltip="One or More Rules Active"><mat-icon /></span>
        <span *ngIf="Rules.length == 0" class="app-icon app-icon--notifications" style="margin-left: 1em; color: rgb(0, 204, 0);"
            matTooltip="No Rules Active"><mat-icon /></span>

        <span *ngIf="Webhooks.length > 0" class="app-icon app-icon--webhook" style="margin-left: 1em; color: var(--color-red);"
            matTooltip="One or More Webhooks Offline"><mat-icon /></span>
        <span *ngIf="Webhooks.length == 0" class="app-icon app-icon--webhook" style="margin-left: 1em; color: rgb(0, 204, 0);"
            matTooltip="No Webhooks Offline"><mat-icon /></span>
    </div>
    <div *ngIf="!isMobileView then notMobile else mobile"></div>

    <ng-template #healthInfo>
        <div class="health-score">
            <div>
                <span style="font-weight: bold; font-size: larger;">Health Score</span><br>
                <span>This Panel Displays what the System's <b>Current</b> State of Health is.</span><br>
                <span>The System's Health Score is: <b>{{ HealthValue }}/4</b></span><br>
                <span>A Score of {{ HealthValue }} Indicates that </span>
                <span *ngIf="HealthValue == 4">No Issues Have Been Detected.</span>
                <span *ngIf="HealthValue == 3">One Type of Issue Has Been Detected.</span>
                <span *ngIf="HealthValue == 2">Two Types of Issue Have Been Detected.</span>
                <span *ngIf="HealthValue == 1">Three Types of Issue Have Been Detected.</span><br>
            </div>
            <div>
                <span style="font-weight: bold; font-size: larger;">Issues</span><br>
                <span *ngIf="Datapoints.length > 1">There are <b>{{ Datapoints.length }}</b> Sensors Offline <br>
                </span>
                <span *ngIf="Datapoints.length == 1">There is <b>1</b> Sensor Offline <br> </span>
                <span *ngIf="Rules.length > 1">There are <b>{{ Rules.length }}</b> Rules Active <br> </span>
                <span *ngIf="Rules.length == 1">There is <b>1</b> Rule Active <br> </span>
                <span *ngIf="Webhooks.length > 1">There are <b>{{ Webhooks.length }}</b> Webhooks Offline <br> </span>
                <span *ngIf="Webhooks.length == 1">There is <b>1</b> Webhook Offline <br> </span>
            </div>
        </div>
    </ng-template>

    <ng-template #notMobile>
        <div class="gauge-info">
            <ng-template [ngTemplateOutlet]="healthInfo"></ng-template>
            <div class="gauge-box alignColumn">
                <ejs-circulargauge [legendSettings]="legendSettings" height="250px" background='transparent'
                    (load)="load($event)" [margin]="'0px'">
                    <e-axes>
                        <e-axis radius="90%" startAngle=270 endAngle=90 minimum=0 maximum=4 [majorTicks]="majorTicks"
                            [minorTicks]="minorTicks">
                            <e-ranges>
                                <e-range start="4" end="2.66" startWidth=40 endWidth=40 radius="60%" color="green"
                                    legendText="Good">
                                </e-range>
                                <e-range start="2.66" end="1.33" startWidth=40 endWidth=40 radius="60%" color="orange"
                                    legendText="Some Issues"></e-range>
                                <e-range start="1.33" end="0" startWidth=40 endWidth=40 radius="60%" color="red"
                                    legendText="Poor">
                                </e-range>
                            </e-ranges>
                            <e-pointers>
                                <e-pointer [value]="HealthValue" radius='80%' pointerWidth="10"
                                    color="var(--default-NAV-Color)">
                                </e-pointer>
                            </e-pointers>
                        </e-axis>
                    </e-axes>
                </ejs-circulargauge>
            </div>
        </div>
    </ng-template>

    <ng-template #mobile>
        <ng-template [ngTemplateOutlet]="healthInfo"></ng-template>
    </ng-template>

    <hr>
    <div class="listbox-div">
        <div class="scrollable-box">
            <span> Offline Sensors </span>
            <ejs-listview [dataSource]='Datapoints' [fields]="fieldsDP" cssClass='e-list-template'>
                <ng-template #template let-data>
                    <span>{{ data.SensorName }}</span>
                </ng-template>
            </ejs-listview>
        </div>
        <div class="scrollable-box">
            <span> Active Rules </span>
            <ejs-listview [dataSource]='Rules' [fields]="fieldsR" cssClass='e-list-template'>
                <ng-template #template let-data>
                    <span routerLink="/rules/{{data.RuleID}}">{{ data.RuleDescription }}</span>
                </ng-template>
            </ejs-listview>
        </div>
        <div class="scrollable-box">
            <span> Webhooks Offline </span>
            <ejs-listview [dataSource]='Webhooks' [fields]="fieldsW" cssClass='e-list-template'>
                <ng-template #template let-data>
                    <span>{{ data.ClientWebhookID }} - {{ data.Description }}</span>
                </ng-template>
            </ejs-listview>
        </div>
    </div>
</div>